<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M22.06 9.56a1.5 1.5 0 00-2.12-2.12l-15.5 15.5a1.5 1.5 0 000 2.12l15.5 15.5a1.5 1.5 0 002.12-2.12L7.622 24l14.44-14.44zm18.5 0a1.5 1.5 0 00-2.12-2.12l-15.5 15.5a1.5 1.5 0 000 2.12l15.5 15.5a1.5 1.5 0 002.12-2.12L26.122 24l14.44-14.44z"/></svg>